// TODO: when core is in monorepo, these should only be defined once
export var MemberAttributeType;

(function (MemberAttributeType) {
  MemberAttributeType["PURCHASE"] = "purchase";
  MemberAttributeType["SUBSCRIPTION"] = "subscription";
  MemberAttributeType["PLAN_WAITLIST"] = "plan_waitlist";
  MemberAttributeType["ADDRESS"] = "address";
})(MemberAttributeType || (MemberAttributeType = {}));